import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabase';

const BRAND  = '#E8940A';
const BRAND2 = '#F5A623';

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [password,   setPassword]   = useState('');
  const [password2,  setPassword2]  = useState('');
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState('');
  const [done,       setDone]       = useState(false);
  const [ready,      setReady]      = useState(false);
  const [show,       setShow]       = useState(false);
  const [show2,      setShow2]      = useState(false);

  useEffect(() => {
    // Supabase redirects here with tokens in the URL hash
    // e.g. /reset-password#access_token=...&refresh_token=...&type=recovery
    const hash = window.location.hash.substring(1);
    if (!hash) { navigate('/login'); return; }
    const params = Object.fromEntries(new URLSearchParams(hash));
    if (!params.access_token || params.type !== 'recovery') {
      navigate('/login');
      return;
    }
    supabase.auth.setSession({
      access_token: params.access_token,
      refresh_token: params.refresh_token,
    }).then(({ error }) => {
      if (error) navigate('/login');
      else setReady(true);
    });
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Şifrə ən az 6 simvoldan ibarət olmalıdır');
      return;
    }
    if (password !== password2) {
      setError('Şifrələr eyni deyil');
      return;
    }
    setLoading(true);
    try {
      const { error: err } = await supabase.auth.updateUser({ password });
      if (err) throw err;
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message || 'Xəta baş verdi. Yenidən cəhd edin.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', -apple-system, sans-serif; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
        .rp-page { min-height:100vh; display:flex; align-items:center; justify-content:center; background:linear-gradient(160deg,#FFF9F0 0%,#FFF3D6 100%); padding:24px 16px; }
        .rp-card { width:100%; max-width:440px; background:#fff; border-radius:24px; padding:48px 40px; box-shadow:0 8px 48px rgba(232,148,10,0.12); border:1px solid #FDE68A; animation:fadeUp 0.5s ease; }
        .rp-logo { display:flex; align-items:center; gap:10px; justify-content:center; margin-bottom:32px; }
        .rp-logo-icon { width:44px; height:44px; border-radius:13px; background:linear-gradient(135deg,${BRAND},${BRAND2}); display:flex; align-items:center; justify-content:center; font-size:22px; box-shadow:0 4px 14px rgba(232,148,10,0.35); }
        .rp-logo-name { font-size:22px; font-weight:900; color:#1A1207; }
        .rp-icon-wrap { width:72px; height:72px; border-radius:20px; background:rgba(232,148,10,0.10); border:2px solid rgba(232,148,10,0.2); display:flex; align-items:center; justify-content:center; font-size:32px; margin:0 auto 20px; }
        .rp-title { font-size:26px; font-weight:900; color:#0F172A; text-align:center; margin-bottom:8px; letter-spacing:-0.4px; }
        .rp-subtitle { font-size:14px; color:#64748B; text-align:center; margin-bottom:32px; line-height:1.6; }
        .rp-form { display:flex; flex-direction:column; gap:18px; }
        .rp-field { display:flex; flex-direction:column; gap:7px; }
        .rp-label { font-size:13px; font-weight:700; color:#374151; }
        .rp-input-wrap { display:flex; align-items:center; border:1.5px solid #E2E8F0; border-radius:12px; overflow:hidden; background:#FAFAFA; transition:border-color 0.2s,box-shadow 0.2s; }
        .rp-input-wrap:focus-within { border-color:${BRAND}; box-shadow:0 0 0 3px rgba(232,148,10,0.12); background:#fff; }
        .rp-icon { padding:0 12px; font-size:16px; line-height:48px; background:#F8FAFC; border-right:1px solid #E2E8F0; user-select:none; }
        .rp-input { flex:1; border:none; outline:none; padding:13px 14px; font-size:14px; color:#0F172A; background:transparent; font-family:inherit; }
        .rp-eye { padding:0 12px; cursor:pointer; background:none; border:none; font-size:16px; color:#94A3B8; }
        .rp-error { display:flex; align-items:center; gap:8px; background:#FEF9E7; border:1px solid #FDE68A; border-radius:10px; padding:10px 14px; font-size:13px; color:#92400E; font-weight:500; }
        .rp-btn { display:flex; align-items:center; justify-content:center; gap:8px; background:linear-gradient(135deg,${BRAND} 0%,${BRAND2} 100%); color:#fff; border:none; border-radius:12px; padding:14px; font-size:15px; font-weight:700; cursor:pointer; transition:all 0.2s; box-shadow:0 4px 18px rgba(232,148,10,0.40); font-family:inherit; }
        .rp-btn:hover:not(:disabled) { transform:translateY(-2px); box-shadow:0 8px 24px rgba(232,148,10,0.50); }
        .rp-btn:disabled { opacity:0.72; cursor:not-allowed; }
        .btn-spinner { width:16px; height:16px; border:2.5px solid rgba(255,255,255,0.35); border-top-color:#fff; border-radius:50%; animation:spin 0.7s linear infinite; }
        .rp-back { display:flex; align-items:center; justify-content:center; gap:6px; margin-top:20px; font-size:13px; color:#64748B; text-decoration:none; font-weight:600; transition:color 0.2s; }
        .rp-back:hover { color:${BRAND}; }
        .rp-success { text-align:center; padding:8px 0; animation:fadeUp 0.4s ease; }
        .rp-success-icon { font-size:56px; margin-bottom:16px; display:block; }
        .rp-success-title { font-size:22px; font-weight:800; color:#0F172A; margin-bottom:10px; }
        .rp-success-desc { font-size:14px; color:#64748B; line-height:1.65; }
      `}</style>

      <div className="rp-page">
        <div className="rp-card">
          <div className="rp-logo">
            <div className="rp-logo-icon">☕</div>
            <span className="rp-logo-name">Cafegoo</span>
          </div>

          {done ? (
            <div className="rp-success">
              <span className="rp-success-icon">✅</span>
              <div className="rp-success-title">Şifrə yeniləndi!</div>
              <p className="rp-success-desc">Giriş səhifəsinə yönləndirilirsiniz...</p>
            </div>
          ) : !ready ? (
            <div style={{ textAlign: 'center', padding: '40px 0' }}>
              <div className="btn-spinner" style={{ margin: '0 auto', borderTopColor: BRAND }} />
            </div>
          ) : (
            <>
              <div className="rp-icon-wrap">🔐</div>
              <h1 className="rp-title">Yeni şifrə təyin et</h1>
              <p className="rp-subtitle">Hesabınız üçün yeni şifrə daxil edin.</p>

              <form onSubmit={handleSubmit} className="rp-form">
                <div className="rp-field">
                  <label className="rp-label">Yeni şifrə</label>
                  <div className="rp-input-wrap">
                    <span className="rp-icon">🔒</span>
                    <input
                      className="rp-input"
                      type={show ? 'text' : 'password'}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Ən az 6 simvol"
                      required
                      autoFocus
                    />
                    <button type="button" className="rp-eye" onClick={() => setShow(s => !s)}>
                      {show ? '🙈' : '👁'}
                    </button>
                  </div>
                </div>

                <div className="rp-field">
                  <label className="rp-label">Şifrəni təsdiqlə</label>
                  <div className="rp-input-wrap">
                    <span className="rp-icon">🔒</span>
                    <input
                      className="rp-input"
                      type={show2 ? 'text' : 'password'}
                      value={password2}
                      onChange={e => setPassword2(e.target.value)}
                      placeholder="Şifrəni təkrar daxil edin"
                      required
                    />
                    <button type="button" className="rp-eye" onClick={() => setShow2(s => !s)}>
                      {show2 ? '🙈' : '👁'}
                    </button>
                  </div>
                </div>

                {error && (
                  <div className="rp-error">
                    <span>⚠️</span> {error}
                  </div>
                )}

                <button type="submit" className="rp-btn" disabled={loading}>
                  {loading && <span className="btn-spinner" />}
                  {loading ? 'Yenilənir...' : 'Şifrəni Yenilə →'}
                </button>
              </form>

              <Link to="/login" className="rp-back">
                ← Girişə qayıt
              </Link>
            </>
          )}
        </div>
      </div>
    </>
  );
}
